import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export async function requestCadNotification(productCode: string) {
  const url = occUrl(`/p/subscribe-cad-availability/${productCode}`);

  const response = await occFetch(url, {
    method: "POST",
  });

  if (response.ok) {
    return;
  }
  throw new Error(response.status + "");
}
